import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';
import img_pages_resources_icon_1 from '@/assets/svg/pages-resources-icon-1.svg';
import img_pages_resources_icon_2 from '@/assets/svg/pages-resources-icon-2.svg';
import img_pages_resources_icon_3 from '@/assets/svg/pages-resources-icon-3.svg';
import pdf_install from '@/assets/pdf/install.pdf';
import pdf_molding from '@/assets/pdf/molding.pdf';
import pdf_warranty from '@/assets/pdf/warranty.pdf';

const Resources = () => {
  const resources = [
    {
      title: 'Installation & Care',
      icon: img_pages_resources_icon_1,
      link: pdf_install,
    },
    {
      title: 'Molding',
      icon: img_pages_resources_icon_3,
      link: pdf_molding,
    },
    {
      title: 'Warranty',
      icon: img_pages_resources_icon_2,
      link: pdf_warranty,
    },
  ];

  return (
    <div className={styles['resources-page']}>
      <div className={styles.page}>
        <section className={styles['resources-hero']}>
          <div className={styles['resources-hero__overlay']}>
            <SiteTopNav />
          </div>
        </section>

        <main className={styles['resources-main']}>
          <section className={styles['resources-intro']}>
            <h1 className={styles['resources-intro__title']} data-motion="hero">
              Engineered Floors
            </h1>
            <p className={styles['resources-intro__lead']} data-motion="copy">
              With years of expertise and experience, Sakura Floors is proud to be regarded as a
              manufacturing leader. Every decision is inspired by our main mission, which is to
              provide the highest standard of product and services to both retailers and customers.
            </p>
          </section>

          <section className={styles['resource-cards']} aria-label="Resources">
            {resources.map(r => (
              <article key={r.title} className={styles['resource-card']} data-motion="card">
                <h2 className={styles['resource-card__title']}>{r.title}</h2>
                <div className={styles['resource-card__iconWrap']}>
                  <img
                    className={styles['resource-card__icon']}
                    alt=""
                    referrerPolicy="no-referrer"
                    src={r.icon}
                  />
                </div>
                <a
                  className={styles['resource-card__cta']}
                  href={r.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${r.title} read more`}
                  data-motion-interactive="press"
                >
                  <span className={styles['resource-card__ctaLabel']}>READ MORE</span>
                </a>
              </article>
            ))}
          </section>

          <section className={styles['resources-about']} data-motion="section">
            <h2 className={styles['resources-about__title']} data-motion="title">
              about Sakura floors
            </h2>
            <p className={styles['resources-about__text']} data-motion="copy">
              In this rapidly changing industry, we’ve realized the importance of continually
              updating our approach to stay relevant in the market, and are committed to just that.
              We invite you to browse through our inventory and contact us with any questions.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Resources;
